import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: 'home',
      component: () => import('./views/wxmall/index.vue')
    },
    {
      path: "/gd/",
      name: "gd",
      component: () => import('./views/gdPcmall/layout.vue'),
      redirect: 'gdhome',
      children: [{
          path: 'gdlogin',
          name: 'gd-login',
          component: () => import('./views/gdPcmall/login.vue')
        },
        {
          path: 'gdhome',
          name: 'gd-home',
          component: () => import('./views/gdPcmall/home.vue')
        },
        {
          path: "/gdpolicy/",
          name: "gd-policy",
          component: () => import('./views/gdPcmall/policy/layout.vue'),
          children: [
            {
              path: 'ordered', // 已出单订单
              name: 'gdordered',
              component: () => import('./views/gdPcmall/policy/ordered.vue'),
            },
            {
              path: 'flordered', // 已出单订单
              name: 'flordered',
              component: () => import('./views/gdPcmall/fulian/ordered.vue'),
            },
            {
              name: 'gdmanage',
              path: 'manage', // 保单
              component: () => import('./views/gdPcmall/policy/manage.vue'),
            },
            {
              path: 'changegdPwd', // 修改密码
              name: 'changegdPwd',
              component: () => import('./views/gdPcmall/userInfo/changePwd.vue'),
            },
          ]
        },
        {
          name: 'modify',
          path: 'modify/:id', // 个单批改
          component: () => import('./views/gdPcmall/policy/modify.vue'),
        },
        {
          name: 'modifyP',
          path: 'modifyP/:id', // 团单批改
          component: () => import('./views/gdPcmall/policy/modifyP.vue'),
        }
      ]
    },
    {
      path: "/login",
      name: "login",
      component: () => import('./views/wxmall/login.vue')
    },
    {
      path: "/forgetPwd",
      name: "forgetPwd",
      component: () => import('./views/wxmall/login.vue')
    },
    {
      path: "/register",
      name: "register",
      component: () => import('./views/wxmall/register.vue')
    },
    {
      path: "/contactUs", //联系我们
      name: "contactUs",
      component: () => import('./views/wxmall/contactUs.vue')
    },
    {
      path: "/commonQuestion", //常见问题
      name: "commonQuestion",
      component: () => import('./views/wxmall/commonQuestion.vue')
    },
    {
      path: "/claimsGuide", //理赔指引
      name: "claimsGuide",
      component: () => import('./views/wxmall/claimsGuide.vue')
    },
    {
      path: "/service", //救援服务
      name: "service",
      component: () => import('./views/wxmall/service.vue')
    },
    {
      path: "/policyResult", //操作结果提示页面
      name: "policyResult",
      component: () => import('./views/wxmall/policyResult.vue')
    },
    {
      path: "/aboutUs", //公司介绍
      name: "aboutUs",
      component: () => import('./views/wxmall/aboutUs.vue')
    },
    {
      path: "/invoice/",
      name: "invoice",
      component: () => import('./views/wxmall/invoice/layout.vue'),
      children: [{
        path: 'queryInvoice', // 发票查询
        name: 'queryInvoice',
        component: () => import('./views/wxmall/invoice/queryInvoice.vue')
      }]
    },
    {
      path: "/policy/",
      name: "policy",
      meta: {
        requiresAuth: true
      },
      component: () => import('./views/wxmall/policy/layout.vue'),
      children: [{
          path: 'manage', // 保单批改
          name: 'manage',
          // linkActiveClass: 'active',
          component: () => import('./views/wxmall/policy/manage.vue'),
        },
        {
          path: 'order', // 订单
          name: 'order',
          component: () => import('./views/wxmall/policy/order.vue'),
        },
        {
          path: 'ordered', // 已出单订单
          name: 'ordered',
          component: () => import('./views/wxmall/policy/ordered.vue'),
        },
        {
          path: 'query', // 批改查询
          name: 'query',
          component: () => import('./views/wxmall/policy/query.vue'),
        },
        {
          path: 'renewed', // 待续保保单
          name: 'renewed',
          component: () => import('./views/wxmall/policy/renewed.vue'),
        },
        {
          path: 'surrender', // 退保管理
          name: 'surrender',
          component: () => import('./views/wxmall/policy/surrender.vue'),
        }
      ]
    },
    {
      path: "/zql",
      name: "zql", // 中青旅，不要删
      component: () => import("./views/ZQL.vue")
    },
    {
      path: "/sd",
      name: "sd", // 中青旅，不要删
      component: () => import("./views/SD.vue")
    },
    {
      path: "/userInfo/",
      name: "userInfo",
      meta: {
        requiresAuth: true
      },
      component: () => import('./views/wxmall/userInfo/layout.vue'),
      children: [{
          path: 'addCard', // 添加绑定证件
          name: 'addCard',
          component: () => import('./views/wxmall/userInfo/addCard.vue'),
        },
        {
          path: 'cardList', //已绑定证件
          name: 'cardList',
          component: () => import('./views/wxmall/userInfo/cardList.vue'),
        },
        {
          path: 'changePwd', // 修改密码
          name: 'changePwd',
          component: () => import('./views/wxmall/userInfo/changePwd.vue'),
        },
      ]
    },
    {
      path: '/quote/',
      name: 'quote',
      component: () => import('./views/quote/layout.vue'),
      children: [{
        //MediLink-Global中端小团体报价器
        path: 'medilink',
        name: 'medilink',
        component: () => import('./views/quote/medilinkTA.vue')
      }, {
        path: 'medilink-preview',
        name: 'medilink-preview',
        component: () => import('./views/quote/medilinkTA.vue')
      },{
        //Aon MediLink SME Plan 报价器-中国大陆计划
        path: 'medilinkAonMC',
        name: 'medilinkAonMC',
        component: () => import('./views/quote/medilinkAonMC.vue')
      },{
        //Aon MediLink SME Plan 报价器-大中华-全球除美-全球计划
        path: 'medilinkAonGCW',
        name: 'medilinkAonGCW',
        component: () => import('./views/quote/medilinkAonGCW.vue')
      }]
    },
    //史带报价器部分--start
    {
      path:'/BJQ/',  //史带报价器
      name:'BJQ',
      component: () => import('./views/SDBJQ/mobile/layout.vue'),
      redirect:{name:'mindex'},
      children:[
        {
          path:'mindex',  //史带报价器
          name:'mindex',
          component: () => import('./views/SDBJQ/mobile/BJQ.vue')
        },
        {
          path:'display/:show',  //史带报价器
          name:'display',
          component: () => import('./views/SDBJQ/mobile/BJQ.vue')
        },
      ]
    },
    {
      path:'/modelContent',  //投保须知
      name:'modelContent',
      component: () => import('./views/SDBJQ/modelContent.vue')
    },
    {
      path:'/list',  //史带报价器列表
      name:'list',
      component: () => import('./views/SDBJQ/list.vue')
    },
    {
      path:'/edit',  //史带报价器配置页面
      name:'edit',
      component: () => import('./views/SDBJQ/index.vue')
    },
    {
      path:'/Setting',  //史带报价器配置页面
      name:'Setting',
      component: () => import('./views/SDBJQ/index.vue')
    },
    {
      path:'/backstage',  //史带报价器配置页面
      name:'backstage',
      component: () => import('./views/SDBJQ/backstage.vue')
    },
    //史带报价器部分--end
    {
      path:'/khcx',  //客户查询
      name:'khcx',
      component: () => import('./views/quote/components/customerQuery.vue')
    },
  ]
});